import {callURL} from './call';
import messageShow from "./messageShow";
import {push} from "connected-react-router";
import {ADV_ID_ROUTE} from "../components/Root/routes";
import {UPDATE_DATA} from "../types";
import {advisorProfile, signerURL} from "../url";

const advlogin= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            const onResultInfo= (resultInfo) =>
            {
                if(resultInfo && resultInfo[1].success)
                {
                    const profile=resultInfo[1].result.profile;
                    if(advisorProfile===profile)
                    {
                        formValues.advisor=true;
                        dispatch({type:UPDATE_DATA,payload:formValues});
                        dispatch(push(ADV_ID_ROUTE));
                    }
                    else
                        dispatch(messageShow({message: "Error, perfil del usuario debe ser asesor", type: 'error'}));
                }
                else
                    dispatch(messageShow({message: resultInfo[1].detail, type: 'error'}));
            }
            dispatch(callURL(signerURL,"rest/UserService/getUserInfo",formValues,onResultInfo));
        }

        else
            dispatch(messageShow({message: result[1].detail, type: 'error'}));
    }
    dispatch(callURL(signerURL,"rest/LoginService/checkBasicAuthentication",formValues,onResult));
};
export default advlogin;